/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PaymentsGetReferralCodesResult } from '../models/payments-get-referral-codes-result';
import { ReferralCodesGetReferralCodeQuery } from '../models/referral-codes-get-referral-code-query';
import { ReferralCodesGetReferralCodeResult } from '../models/referral-codes-get-referral-code-result';
import { ReferralCodesRemoveReferralCodeCommand } from '../models/referral-codes-remove-referral-code-command';
import { ReferralCodesRemoveReferralCodeResult } from '../models/referral-codes-remove-referral-code-result';
import { ReferralCodesUpsertReferralCodeCommand } from '../models/referral-codes-upsert-referral-code-command';
import { ReferralCodesUpsertReferralCodeResult } from '../models/referral-codes-upsert-referral-code-result';

@Injectable({
  providedIn: 'root',
})
export class ReferralCodesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation upsertReferralCode
   */
  static readonly UpsertReferralCodePath = '/api/ReferralCodes/UpsertReferralCode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertReferralCode()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  upsertReferralCode$Response(params?: {
    context?: HttpContext
    body?: ReferralCodesUpsertReferralCodeCommand
  }
): Observable<StrictHttpResponse<ReferralCodesUpsertReferralCodeResult>> {

    const rb = new RequestBuilder(this.rootUrl, ReferralCodesService.UpsertReferralCodePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReferralCodesUpsertReferralCodeResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `upsertReferralCode$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  upsertReferralCode(params?: {
    context?: HttpContext
    body?: ReferralCodesUpsertReferralCodeCommand
  }
): Observable<ReferralCodesUpsertReferralCodeResult> {

    return this.upsertReferralCode$Response(params).pipe(
      map((r: StrictHttpResponse<ReferralCodesUpsertReferralCodeResult>) => r.body as ReferralCodesUpsertReferralCodeResult)
    );
  }

  /**
   * Path part for operation removeReferralCode
   */
  static readonly RemoveReferralCodePath = '/api/ReferralCodes/RemoveReferralCode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeReferralCode()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeReferralCode$Response(params?: {
    context?: HttpContext
    body?: ReferralCodesRemoveReferralCodeCommand
  }
): Observable<StrictHttpResponse<ReferralCodesRemoveReferralCodeResult>> {

    const rb = new RequestBuilder(this.rootUrl, ReferralCodesService.RemoveReferralCodePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReferralCodesRemoveReferralCodeResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeReferralCode$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeReferralCode(params?: {
    context?: HttpContext
    body?: ReferralCodesRemoveReferralCodeCommand
  }
): Observable<ReferralCodesRemoveReferralCodeResult> {

    return this.removeReferralCode$Response(params).pipe(
      map((r: StrictHttpResponse<ReferralCodesRemoveReferralCodeResult>) => r.body as ReferralCodesRemoveReferralCodeResult)
    );
  }

  /**
   * Path part for operation getReferralCode
   */
  static readonly GetReferralCodePath = '/api/ReferralCodes/GetReferralCode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReferralCode()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getReferralCode$Response(params?: {
    context?: HttpContext
    body?: ReferralCodesGetReferralCodeQuery
  }
): Observable<StrictHttpResponse<ReferralCodesGetReferralCodeResult>> {

    const rb = new RequestBuilder(this.rootUrl, ReferralCodesService.GetReferralCodePath, 'get');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReferralCodesGetReferralCodeResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getReferralCode$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getReferralCode(params?: {
    context?: HttpContext
    body?: ReferralCodesGetReferralCodeQuery
  }
): Observable<ReferralCodesGetReferralCodeResult> {

    return this.getReferralCode$Response(params).pipe(
      map((r: StrictHttpResponse<ReferralCodesGetReferralCodeResult>) => r.body as ReferralCodesGetReferralCodeResult)
    );
  }

  /**
   * Path part for operation getReferralCodes
   */
  static readonly GetReferralCodesPath = '/api/ReferralCodes/GetReferralCodes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReferralCodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReferralCodes$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<PaymentsGetReferralCodesResult>> {

    const rb = new RequestBuilder(this.rootUrl, ReferralCodesService.GetReferralCodesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentsGetReferralCodesResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getReferralCodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReferralCodes(params?: {
    context?: HttpContext
  }
): Observable<PaymentsGetReferralCodesResult> {

    return this.getReferralCodes$Response(params).pipe(
      map((r: StrictHttpResponse<PaymentsGetReferralCodesResult>) => r.body as PaymentsGetReferralCodesResult)
    );
  }

}
